import axios from "../../../../../apis/dvdlocator";

/**
 * Reads supplier_feed_runs through its datagrid endpoint. Rows come back
 * nested by table ({ supplier_feed_runs: {...} }); this flattens them.
 */
export async function fetchFeedRuns({ pageSize = 200, filterItems = [] } = {}) {
  const response = await axios.post("/datagrid/supplier-feed-runs", {
    operation: "READ",
    paginationModel: { page: 0, pageSize },
    sortModel: [{ field: "supplier_feed_runs.started_at", sort: "desc" }],
    filterModel: { items: filterItems },
    globalSearch: "",
    groupKeys: [],
    groupFields: [],
  });
  const rows = response.data?.data || [];
  return rows.map((row) => row.supplier_feed_runs || row);
}

/** The most recent run per supplier key, in the order first seen (newest first). */
export function latestRunPerSupplier(runs) {
  const seen = new Map();
  for (const run of runs) {
    if (!seen.has(run.supplier_key)) seen.set(run.supplier_key, run);
  }
  return Array.from(seen.values());
}

/** Waits for the run recorded for an uploaded file to finish. */
export async function waitForFileRun(
  fileName,
  { attempts = 20, intervalMs = 3000 } = {}
) {
  for (let i = 0; i < attempts; i++) {
    const runs = await fetchFeedRuns({
      pageSize: 5,
      filterItems: [
        {
          field: "supplier_feed_runs.file_name",
          operator: "equals",
          value: fileName,
        },
      ],
    });
    const run = runs[0];
    if (run && run.status !== "running") return run;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return null;
}
